import React, { memo } from 'react';
import { Box, Typography, Card, CardContent, Stack } from '@mui/material';
import { RouteComponentProps } from 'react-router-dom';
import PatientListComponent from '../patients/patient-listing.component';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import PatientHomePageComponent from './patient-home-page.component';
import Helper from '../../utils/helper';
import { environment } from '../../environments/environment';

interface IProps extends RouteComponentProps {
  history: any;
  location: any;
  match: any;
}

const HomePageComponent: React.FC<IProps> = ({ history, location, match }) => {
  const loggedInUser = useSelector(
    (state: RootState) => state.commonData.loggedInUser
  );

  return (
    <Stack direction='column'>
      {!loggedInUser?.roles && <Box sx={{ padding: '2rem 3rem' }}>
        <Card variant="outlined">
          <CardContent>
            <Typography color="textSecondary">{'No roles are configured for your user profile. Access cannot be granted until roles are assigned'}</Typography>
          </CardContent>
        </Card>
      </Box>
      }
      {Helper.checkGroup(environment.okta.groups, loggedInUser?.roles) &&
        <PatientListComponent
          history={history}
          location={location}
          match={match}
        />
      }
      {loggedInUser?.roles?.includes('PATIENT') &&
        <PatientHomePageComponent history={history} location={location} match={match} />
      }
    </Stack>
  );
};

export default memo(HomePageComponent);
